import dayjs from 'dayjs'
import PrintQueueEntry from '../../../../types/api/print-queue-entry'
import { getPrintQueueEntryAreaM2, getPrintQueueEntryMinutes } from './build-print-plan-date-groups'

export const DURST_QUEUE_NO_DAY_KEY = '__NO_DAY__'

export interface DurstPrintDayGroup {
    key: string
    plannedPrintDate: string
    dayOfWeek: string
    dateLabel: string
    entries: PrintQueueEntry[]
    jobsCount: number
    totalArea: number
    totalMinutes: number
    isFallbackGroup?: boolean
}

const DAY_OF_WEEK_LABELS = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ']

function normalizePlannedPrintDate(value?: string | null) {
    if (!value) return ''

    const date = dayjs(value)

    return date.isValid() ? date.format('YYYY-MM-DD') : ''
}

export function getDurstPrintDayGroupLabel(plannedPrintDate: string) {
    if (plannedPrintDate === DURST_QUEUE_NO_DAY_KEY) return 'Без дня'

    const currentDate = dayjs(plannedPrintDate)

    if (!currentDate.isValid()) return 'Без дня'
    if (currentDate.isSame(dayjs(), 'day')) return 'Сегодня'
    if (currentDate.isSame(dayjs().add(1, 'day'), 'day')) return 'Завтра'

    return currentDate.format('DD.MM')
}

export function buildDurstPrintDayGroups(entries: PrintQueueEntry[]): DurstPrintDayGroup[] {
    if (!entries.length) {
        return []
    }

    const entriesByGroup = new Map<string, PrintQueueEntry[]>()

    entries
        .slice()
        .sort((a, b) => a.sort - b.sort)
        .forEach(entry => {
            const plannedPrintDate = normalizePlannedPrintDate(entry.plannedPrintDate)
            const key = plannedPrintDate || DURST_QUEUE_NO_DAY_KEY
            const groupEntries = entriesByGroup.get(key) || []

            groupEntries.push(entry)
            entriesByGroup.set(key, groupEntries)
        })

    return [...entriesByGroup.entries()]
        .sort(([dateA], [dateB]) => {
            if (dateA === DURST_QUEUE_NO_DAY_KEY) return -1
            if (dateB === DURST_QUEUE_NO_DAY_KEY) return 1

            return dayjs(dateA).valueOf() - dayjs(dateB).valueOf()
        })
        .map(([key, groupEntries]) => {
            const totalArea = groupEntries.reduce(
                (acc, entry) => acc + getPrintQueueEntryAreaM2(entry),
                0
            )
            const totalMinutes = groupEntries.reduce(
                (acc, entry) => acc + getPrintQueueEntryMinutes(entry),
                0
            )
            const currentDate = key === DURST_QUEUE_NO_DAY_KEY ? null : dayjs(key)

            return {
                key,
                plannedPrintDate: key,
                dayOfWeek: currentDate?.isValid() ? DAY_OF_WEEK_LABELS[currentDate.day()] : '',
                dateLabel: currentDate?.isValid() ? currentDate.format('DD.MM') : 'Без дня',
                entries: groupEntries,
                jobsCount: groupEntries.length,
                totalArea,
                totalMinutes,
                isFallbackGroup: key === DURST_QUEUE_NO_DAY_KEY,
            }
        })
}
